import { render } from "./WavelengthSwitchControl.vue?vue&type=template&id=449d38a2&scoped=true"
import script from "./WavelengthSwitchControl.vue?vue&type=script&lang=js"
export * from "./WavelengthSwitchControl.vue?vue&type=script&lang=js"

import "./WavelengthSwitchControl.vue?vue&type=style&index=0&id=449d38a2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-449d38a2"]])

export default __exports__